
export default function ParksHero() {
  return (
    <section className="relative h-[75vh] min-h-[560px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/7349f0e76fbdf0f208634496807318f5.jpg"
          alt="Roseville Parks and Recreation"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 text-center px-6 w-full max-w-4xl mx-auto">
        <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <i className="ri-leaf-line text-emerald-300"></i>
          <span className="text-white/90 text-sm font-medium">
            75+ Parks &middot; 42 Miles of Trails &middot; 3,800 Acres
          </span>
        </div>
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Parks &amp; Recreation
          <br />
          <span className="text-emerald-300">Directory</span>
        </h1>
        <p className="text-lg text-white/85 mb-8 max-w-2xl mx-auto leading-relaxed">
          Explore Roseville&apos;s world‑class trails, playgrounds, sports facilities,
          dog parks, and nature preserves. Your next outdoor adventure starts here.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <a
            href="#trails"
            className="bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-3 rounded-full font-semibold transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-route-line mr-2"></i>
            Find Trails
          </a>
          <a
            href="#playgrounds"
            className="bg-white/15 hover:bg-white/25 text-white px-8 py-3 rounded-full font-semibold transition-colors backdrop-blur-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-gamepad-line mr-2"></i>
            Playgrounds
          </a>
          <a
            href="#sports"
            className="bg-white/15 hover:bg-white/25 text-white px-8 py-3 rounded-full font-semibold transition-colors backdrop-blur-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-trophy-line mr-2"></i>
            Sports
          </a>
        </div>
      </div>
    </section>
  );
}
